import { t } from "i18next";
import { isEmpty, startCase } from "lodash";
import moment from "moment";
import React, { useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
const TransactionRecordFilter = ({ setFilter, filter, getData }) => {
  const [show, setShow] = useState(false);
  return (
    <app-search-tab
      _ngcontent-serverapp-c3748548866
      _nghost-serverapp-c2684251700
      className="ng-tns-c2684251700-18 ng-tns-c3748548866-17 ng-star-inserted"
    >
      <div
        _ngcontent-serverapp-c2684251700
        className="ng-tns-c2684251700-18 ng-trigger ng-trigger-staggerFadeAnimation tab filter-tab ng-star-inserted"
      >
        <ul
          _ngcontent-serverapp-c2684251700
          className="item-ani ng-tns-c2684251700-18"
        >
          {" "}
          <li
            _ngcontent-serverapp-c2684251700
            className="active ng-tns-c2684251700-125 ng-star-inserted"
          >
            {moment(filter?.fromPeriod).format("YYYY-MM-DD")} -{" "}
            {moment(filter?.toPeriod).format("YYYY-MM-DD")}
          </li>
          {!isEmpty(filter?.payment) && (
            <li
              _ngcontent-serverapp-c2684251700
              className="active ng-tns-c2684251700-125 ng-star-inserted"
            >
              {startCase(filter?.payment)}
            </li>
          )}
          {!isEmpty(filter?.status) && (
            <li
              _ngcontent-serverapp-c2684251700
              className="active ng-tns-c2684251700-125 ng-star-inserted"
            >
              {startCase(filter?.status)}
            </li>
          )}
        </ul>
        <div
          onClick={() => {
            setShow(true);
          }}
          _ngcontent-serverapp-c2684251700
          className="btn search-btn ng-tns-c2684251700-18 ng-star-inserted"
        >
          <span
            _ngcontent-serverapp-c2684251700
            className="item-icon ng-tns-c2684251700-18 ng-star-inserted"
            style={{
              "mask-image": 'url("/assets/Icon/games-filter-icon.svg")',
            }}
          />
        </div>
      </div>

      <div
        _ngcontent-serverapp-c2684251700
        className={`searchpage ng-tns-c2684251700-18 ng-star-inserted ${
          show ? "active" : ""
        } `}
      >
        <div
          _ngcontent-serverapp-c2684251700
          className="search-top-info ng-tns-c2684251700-18"
        >
          <h6
            _ngcontent-serverapp-c2684251700
            className="ng-tns-c2684251700-18 ng-star-inserted"
          >
            {t("TransactionRecordFilter")}
          </h6>

          <div
            onClick={() => {
              setShow(false);
              getData();
            }}
            _ngcontent-serverapp-c2684251700
            className="back ng-tns-c2684251700-18"
            style={{
              "mask-image": 'url("/assets/Icon/icon-arrow-type01.svg")',
            }}
          >
            Back
          </div>
        </div>
        <div
          _ngcontent-serverapp-c2684251700
          className="searchpage-main ng-tns-c2684251700-18"
        >
          {/* <div
            _ngcontent-serverapp-c2684251700
            className="search-checkbox-group check-group ng-tns-c2684251700-18 ng-star-inserted"
          >
            <h2
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-18 ng-star-inserted"
            >
              {t("Status")}
            </h2>

            <ul
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-18"
            >
              {statusOptions?.map((res) => {
                return (
                  <li
                    onClick={() =>
                      setFilter((prev) => {
                        return {
                          ...prev,
                          status: res?.value,
                        };
                      })
                    }
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-18 ng-star-inserted"
                  >
                    <input
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-18"
                      type="checkbox"
                      checked={filter?.status == res?.value}
                    />
                    <label
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-18"
                    >
                      <span
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-18"
                      >
                        {res?.label}
                      </span>
                      <i
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-18"
                        style={{
                          "background-image": 'url("/assets/Other/check.svg")',
                        }}
                      />
                    </label>
                  </li>
                );
              })}
            </ul>
          </div> */}
          <div
            _ngcontent-serverapp-c2684251700
            className="search-checkbox-group check-group ng-tns-c2684251700-18 ng-star-inserted"
          >
            <h2
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-18 ng-star-inserted"
            >
              {t("PaymentType")}
            </h2>

            <ul
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-18"
            >
              {transactionOptions?.map((res) => {
                return (
                  <li
                    onClick={() =>
                      setFilter((prev) => {
                        return {
                          ...prev,
                          payment: res?.value,
                        };
                      })
                    }
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-18 ng-star-inserted"
                  >
                    <input
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-18"
                      type="checkbox"
                      checked={filter?.payment == res?.value}
                    />
                    <label
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-18"
                    >
                      <span
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-18"
                      >
                        {res?.label}
                      </span>
                      <i
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-18"
                        style={{
                          "background-image": 'url("/assets/Other/check.svg")',
                        }}
                      />
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>

          <div
            _ngcontent-serverapp-c2684251700
            className="search-checkbox-group check-group ng-tns-c2684251700-125 ng-star-inserted"
          >
            <h2
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-125 ng-star-inserted"
            >
              {t("Date")}
            </h2>

            <ul
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-125"
            >
              {timeRanges?.map((res) => {
                return (
                  <li
                    onClick={() =>
                      setFilter((prev) => {
                        return {
                          ...prev,
                          fromPeriod: res?.getDays()?.fromPeriod,
                          toPeriod: res?.getDays()?.toPeriod,
                        };
                      })
                    }
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-125 ng-star-inserted"
                  >
                    <input
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-125"
                      type="checkbox"
                      checked={
                        filter?.fromPeriod === res?.getDays()?.fromPeriod &&
                        filter?.toPeriod === res?.getDays()?.toPeriod
                      }
                    />
                    <label
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-125"
                    >
                      <span
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-125"
                      >
                        {res?.name}
                      </span>
                      <i
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-125"
                        style={{
                          "background-image": `url("/assets/Other/check.svg")`,
                        }}
                      />
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>

          <div
            _ngcontent-serverapp-c2684251700
            className="search-checkbox-group check-group ng-tns-c2684251700-125 ng-star-inserted"
          >
            <h2
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-125 ng-star-inserted"
            >
              Date Range
            </h2>

            <DayPicker
              mode="range"
              selected={{
                from: filter?.fromPeriod
                  ? moment(filter.fromPeriod, "YYYY-MM-DD").toDate()
                  : undefined,
                to: filter?.toPeriod
                  ? moment(filter.toPeriod, "YYYY-MM-DD").toDate()
                  : undefined,
              }}
              onSelect={(e) =>
                setFilter((prev) => {
                  return {
                    ...prev,
                    fromPeriod: e?.from
                      ? moment(e.from).format("YYYY-MM-DD")
                      : undefined,
                    toPeriod: e?.to
                      ? moment(e.to).format("YYYY-MM-DD")
                      : undefined,
                  };
                })
              }
              style={{
                "--rdp-accent-color": "#ffb80c" /* selected date → green */,
                "--rdp-accent-background-color":
                  "#043b3d" /* range highlight → gold */,
                "--rdp-day-color": "white",
                color: "white",
              }}
              disabled={{ after: new Date() }}
            />
          </div>
        </div>

        <div
          onClick={() => {
            setShow(false);
            getData();
          }}
          _ngcontent-serverapp-c2684251700
          className="searchpage-bar ng-tns-c2684251700-18"
        >
          <div
            _ngcontent-serverapp-c2684251700
            className="button btn-primary ng-tns-c2684251700-18"
          >
            {t("Confirm")}
          </div>
        </div>
      </div>
    </app-search-tab>
  );
};

export default TransactionRecordFilter;

const statusOptions = [
  {
    label: "Processing",
    value: "processing",
    icon: "/assets/Other/check.svg",
  },
  {
    label: "Rejected",
    value: "rejected",
    icon: "/assets/Other/check.svg",
  },
  {
    label: "Approved",
    value: "approved",
    icon: "/assets/Other/check.svg",
  },
];

const transactionOptions = [
  {
    label: "Deposit",
    value: "deposit",
    icon: "/assets/Other/check.svg",
  },
  {
    label: "Withdrawal",
    value: "withdrawal",
    icon: "/assets/Other/check.svg",
  },
  {
    label: "All",
    value: "all",
    icon: "/assets/Other/check.svg",
  },
];

const timeRanges = [
  {
    name: "Today",
    getDays: () => ({
      fromPeriod: moment().format("YYYY-MM-DD"),
      toPeriod: moment().format("YYYY-MM-DD"),
    }),
  },
  {
    name: "Yesterday",
    getDays: () => ({
      fromPeriod: moment().subtract(1, "days").format("YYYY-MM-DD"),
      toPeriod: moment().format("YYYY-MM-DD"),
    }),
  },
  {
    name: "Last 7 days",
    getDays: () => ({
      fromPeriod: moment().subtract(6, "days").format("YYYY-MM-DD"),
      toPeriod: moment().format("YYYY-MM-DD"),
    }),
  },
  {
    name: "Last 30 days",
    getDays: () => ({
      fromPeriod: moment().subtract(29, "days").format("YYYY-MM-DD"),
      toPeriod: moment().format("YYYY-MM-DD"),
    }),
  },
];
